import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum CommercialInvoiceLineItemKeys {
  itemNumber = 'itemNumber',
  externalItemNumber = 'externalItemNumber',
  description = 'description',
  itemQty = 'itemQty',
  unitPrice = 'unitPrice',
  lineTotal = 'lineTotal',
  lineAmountDue = 'lineAmountDue',
}

export const commercialInvoiceFileDataSchema = yup.object().shape({
  issuer: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    addressLine1: yup.string().nullable().optional(),
    addressLine2: yup.string().nullable().optional(),
    city: yup.string().nullable().optional(),
    state: yup.string().nullable().optional(),
    zipCode: yup.string().nullable().optional(),
    country: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  recipient: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    addressLine1: yup.string().nullable().optional(),
    addressLine2: yup.string().nullable().optional(),
    city: yup.string().nullable().optional(),
    state: yup.string().nullable().optional(),
    zipCode: yup.string().nullable().optional(),
    country: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  companyUrl: yup.string().nullable().optional(),
  invoiceNumber: yup.string().nullable().optional(),
  associatedReferenceNumber: yup.string().nullable().optional(),
  dateIssued: yup.string().nullable().optional(),
  orderNumber: yup.string().nullable().optional(),
  paymentTerms: yup.string().nullable().optional(),
  freightTerms: yup.string().nullable().optional(),
  items: yup
    .array()
    .of(
      yup.object().shape({
        itemNumber: yup.number().nullable().optional(),
        description: yup.string().nullable().optional(),
        externalItemNumber: yup.string().nullable().optional(),
        itemQty: yup.string().nullable().optional(),
        unitPrice: yup.string().nullable().optional(),
        lineTotal: yup.string().nullable().optional(),
        lineAmountDue: yup.string().nullable().optional(),
      }),
    )
    .required(),
  shippingRate: yup.string().nullable().optional(),
  agreement: yup.string().nullable().optional(),
  comments: yup.string().nullable().optional(),
})

export type CommercialInvoiceFileData = yup.InferType<typeof commercialInvoiceFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<CommercialInvoiceFileData>

export const commercialInvoiceFileMappings: RequiredFileData = {
  issuer: {
    companyName: '4c1e4c2a-32b2-44af-ae2a-6bcb7e228ab4',
    addressLine1: '19887065-6a1d-4093-9ab4-0a98b45a32a5',
    addressLine2: '9f3c6f2b-5b42-4a67-9e10-847a5c2b5a21',
    city: '3b7f2c48-1d24-4a3e-9f15-72c89d4c60d2',
    state: 'e24fbd67-92d8-46b9-8d9f-45a47c30f6c5',
    zipCode: '7a9e51d0-4c6f-4a12-9c11-58e34f08e85a',
    country: 'c52e3d8a-62fb-4b0a-9f14-9d5e87b2c3de',
    phoneNumber: 'daf3c5fd-b9cb-42e8-b264-a8cef1944f8d',
    emailAddress: '197e9b07-b569-4ef8-8fa3-66e98927fb4f',
  },
  recipient: {
    companyName: 'e27edc52-1f78-4918-9254-fd536d7c418b',
    addressLine1: '39c05ffd-f239-40c7-ae46-19673ec57f56',
    addressLine2: 'b6e1f3a7-9d42-41e2-b5af-6c28a91de3f1',
    city: '4c9a27d3-18f4-4db2-9e41-7e58d3b92a64',
    state: 'e7d4c8a2-5f30-4a9f-8c27-1f93b8e45d02',
    zipCode: '2f15d8a6-7b92-4e0c-9c31-8a24f7c6d5b9',
    country: '9e34c7b5-62f1-4d3a-8b20-5c6e1a9d4f73',
    phoneNumber: 'a670b36e-6d9d-4ce0-902b-ba527ab37a86',
    emailAddress: 'b52aa41a-d313-4c8c-b91b-4a8804cddc90',
  },
  companyUrl: 'bdea5d06-4dfc-4b39-835c-26d21f7949a6',
  invoiceNumber: '4e6f110f-b647-4726-b746-810c164ca8b3',
  associatedReferenceNumber: '4baee3f7-4503-4446-ad29-a9517122b84f',
  dateIssued: 'b17a2eb7-bad7-4903-929c-d523f8906482',
  orderNumber: '47ca585c-d044-4673-8c26-2b672b929a38',
  paymentTerms: 'e5e06da3-5064-4ee8-991b-228704a77422',
  freightTerms: '1578237d-3aef-4e92-81ea-01163912719b',
  items: [
    {
      itemNumber: null,
      description: '3c3121bb-7b39-4848-b211-43b70ad99e1d',
      externalItemNumber: '53085451-7df9-4508-898f-df6343cd650a',
      itemQty: '2ccf8b54-64ee-4524-852e-5dfa645830e7',
      unitPrice: 'a59e0269-c7e4-4a83-b7e8-6024f278ac81',
      lineTotal: null,
      lineAmountDue: '5bed76a1-12db-4232-ab8e-f207808158e5',
    },
  ],
  shippingRate: 'a25aa665-483b-4367-906f-899bcd4f9429',
  agreement: '7edff360-e271-4704-a562-c51973919792',
  comments: '398b1311-5026-4322-987f-fdd517139028',
}
